<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-wallet-page" style="margin-bottom: 50px;">

  <!-- TOP HEADER -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <button class="appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="appbar-title">{{ "wallet" | transloco }}</h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- BALANCE HERO CARD -->
    <section class="wallet-balance-card">
      <div class="wallet-balance-card__top">
        <div class="wallet-balance-main">
          <span class="wallet-balance-overline">{{ "wallet balance" | transloco }}</span>
          <h2>
            <span dir="ltr">{{ balance }}</span>
            <span>{{ "egpe" | transloco }}</span>
          </h2>
          <p>{{ "Latest transactions" | transloco }}</p>
        </div>

        <div class="wallet-icon-box">
          <img src="/assets/e-commerce/icons/53.webp" alt="wallet" />
        </div>
      </div>
    </section>

    <!-- TRANSACTIONS -->
    <section class="wallet-transactions-card">
      <div class="wallet-section-head">
        <h3>{{ "Latest transactions" | transloco }}</h3>
      </div>

      @if(!transactions || transactions.length === 0){
      <div class="empty-wallet">
        <img src="/assets/e-commerce/icons/74.webp" alt="product" class="product-img">
        <p class="no-data-text">
          {{ "No transactions" | transloco }}
        </p>
      </div>
      }
      @else{
      <div class="txn-list">
        @for(transaction of transactions; track transaction.id || $index){
        <div class="txn" [class.credit]="transaction.type === 'credit'" [class.debit]="transaction.type === 'debit'">

          <div class="txn-left">
            <div class="amt">
              @if(transaction.type === 'debit'){
              -
              }
              @else{
              +
              }
              <span dir="ltr">{{ transaction.amount }}</span>
              {{ "egpe" | transloco }}
            </div>
          </div>

          <div class="txn-right">
            @if(transaction.order_id){
            <div class="title">{{ 'order number' | transloco }} #{{ transaction.order_id }}</div>
            }
            @else{
            <div class="title">{{ transaction.note }}</div>
            }

            <div class="date">{{ formatDate(transaction.created_at) }}</div>
          </div>
        </div>
        }
      </div>
      }
    </section>

  </div>
</div>